import React from 'react';
import { Shield, CheckCircle2 } from 'lucide-react';

const ExchangeSolution = () => {
  const features = [
    'Expert-led Training programs',
    'Role-based and industry-specific paths',
    'Communication, performance, and leadership skills',
    'Continuous professional development'
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-b from-transparent to-blue-950/20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
            Curated for <span className="text-cyan-400">Enterprise</span>
          </h2>
          
          <p className="text-xl text-gray-300 mb-2">Not an open marketplace.</p>
          <p className="text-xl text-gray-300 mb-8">Not ungoverned content.</p>
          
          <p className="text-xl text-white font-semibold mb-8">
            Traain Exchange delivers:
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <div className="space-y-4">
            {features.map((feature, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-5 rounded-xl bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 hover:border-cyan-500/50 transition-all duration-300"
              >
                <CheckCircle2 className="w-6 h-6 text-cyan-400 flex-shrink-0 mt-0.5" />
                <p className="text-lg text-gray-300">{feature}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <div className="inline-flex items-center gap-3 p-6 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <Shield className="w-6 h-6 text-cyan-400" />
            <p className="text-lg text-gray-300">
              All content is <span className="text-white font-semibold">governed, trackable, and aligned</span> to your standards.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExchangeSolution;
